const widthsMap = {
    inter: {
        '0': [63, 69, 63, 69],
        '1': [47, 49, 47, 49],
        '2': [61, 63, 61, 63],
        '3': [64, 66, 64, 66],
        '4': [64, 68, 64, 68],
        '5': [61, 65, 61, 65],
        '6': [63, 66, 63, 66],
        '7': [57, 60, 57, 60],
        '8': [62, 66, 62, 66],
        '9': [63, 66, 63, 66],
        ' ': [28, 23, 28, 23],
        '!': [28, 33, 28, 33],
        '"': [41, 39, 41, 39],
        '#': [63, 65, 63, 65],
        '$': [64, 66, 64, 66],
        '%': [82, 86, 82, 86],
        '&': [64, 68, 64, 68],
        "'": [22, 21, 22, 21],
        '(': [36, 41, 36, 41],
        ')': [36, 41, 36, 41],
        '*': [50, 57, 50, 57],
        '+': [66, 68, 66, 68],
        ',': [28, 31, 28, 31],
        '-': [46, 47, 46, 47],
        '.': [28, 30, 28, 30],
        '/': [36, 39, 36, 39],
        ':': [28, 30, 28, 30],
        ';': [28, 31, 28, 31],
        '<': [66, 68, 66, 68],
        '=': [66, 68, 66, 68],
        '>': [66, 68, 66, 68],
        '?': [51, 57, 51, 57],
        '@': [94, 103, 94, 103],
        'A': [68, 75, 68, 75],
        'B': [65, 66, 65, 66],
        'C': [73, 75, 73, 75],
        'D': [72, 73, 72, 73],
        'E': [60, 62, 60, 62],
        'F': [59, 59, 59, 59],
        'G': [75, 76, 75, 76],
        'H': [74, 75, 74, 75],
        'I': [27, 28, 27, 28],
        'J': [55, 57, 55, 57],
        'K': [65, 69, 65, 69],
        'L': [57, 57, 57, 57],
        'M': [89, 92, 89, 92],
        'N': [76, 74, 76, 74],
        'O': [76, 78, 76, 78],
        'P': [64, 65, 64, 65],
        'Q': [76, 79, 78, 79],
        'R': [64, 66, 64, 66],
        'S': [64, 66, 64, 66],
        'T': [64, 67, 64, 67],
        'U': [74, 73, 74, 73],
        'V': [68, 75, 68, 75],
        'W': [95, 104, 95, 104],
        'X': [64, 72, 64, 72],
        'Y': [67, 73, 67, 73],
        'Z': [63, 67, 63, 67],
        '[': [36, 41, 36, 41],
        '\\': [36, 39, 36, 39],
        ']': [36, 41, 36, 41],
        '^': [47, 49, 47, 49],
        '_': [45, 48, 45, 48],
        '`': [50, 50, 50, 50],
        'a': [57, 58, 57, 58],
        'b': [62, 64, 62, 64],
        'c': [56, 59, 56, 59],
        'd': [62, 64, 62, 64],
        'e': [58, 60, 59, 60],
        'f': [36, 39, 36, 39],
        'g': [61, 64, 61, 64],
        'h': [59, 63, 59, 63],
        'i': [24, 27, 24, 27],
        'j': [24, 27, 24, 27],
        'k': [55, 58, 55, 58],
        'l': [24, 27, 24, 27],
        'm': [87, 91, 87, 91],
        'n': [59, 62, 59, 62],
        'o': [60, 62, 60, 62],
        'p': [61, 64, 61, 64],
        'q': [61, 64, 61, 64],
        'r': [37, 41, 38, 41],
        's': [53, 56, 53, 56],
        't': [37, 39, 37, 39],
        'u': [58, 62, 58, 62],
        'v': [56, 59, 56, 59],
        'w': [82, 85, 82, 85],
        'x': [54, 58, 54, 58],
        'y': [56, 59, 56, 59],
        'z': [54, 57, 54, 58],
        '{': [36, 41, 36, 41],
        '|': [33, 38, 33, 38],
        '}': [36, 41, 36, 41],
        '~': [66, 68, 66, 68],
    },
};

export default widthsMap;
